import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { LoadingAttributeComponent } from '../loading-attribute/loading-attribute.component';

@Component({
    selector: 'ts-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent {
  @Input() count: number;
  @Input() loading = true;
}

@NgModule({
  imports: [CommonModule, LoadingAttributeComponent],
  declarations: [BadgeComponent],
  exports: [BadgeComponent],
})
export class BadgeModule {}
